export default "__VITE_ASSET__bcf8eb6a__"